import { render, staticRenderFns } from "./BookmarkWidget.vue?vue&type=template&id=2997a534"
import script from "@/components/BookmarkWidget/BookmarkWidget.ts?vue&type=script&lang=ts&external"
export * from "@/components/BookmarkWidget/BookmarkWidget.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/BookmarkWidget/BookmarkWidget.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports